<div style="text-align: -webkit-center;text-align: -moz-center;  margin-top: 3rem;">

  <div class="card" style="margin: 16px; text-align: center; width: 70%; min-width: 30rem;">

    <!--ALREADY DONE TEST-->
    <div *ngIf="!done && charged2">
      <p style="font-size: x-large; font-weight: 500;"> {{'ALREADY_DONE_TEST' | translate}} </p>
    </div>

    <!--SPINNER WHILE FETCHING DATA-->
    <div *ngIf="!done && !charged2" style="text-align: -webkit-center;text-align: -moz-center; padding: 2rem 0px">
      <mat-spinner diameter="30"></mat-spinner>
    </div>

    <div *ngIf="done">
      <!--TASK OVERVIEW-->
      <div *ngIf="overview">
        <h1 style="text-align: center; font-size: 3em; margin-bottom: 3rem;  margin-top: 0px;">
          {{'MEM_OW' | translate}}
        </h1>

        <p>
          {{'MEM_P1' | translate}}
        </p>

        <p>
          {{'MEM_P2' | translate}}
        </p>
        <button mat-raised-button class="button" (click)="endOverview()">{{'START' | translate}}</button>
      </div>

      <!--CATEGORISATION TASK-->
      <app-categorisation
        *ngIf="!overview && !testFinished && ((selectedOption[fase] === 'alive') || (selectedOption[fase] === 'manmade'))"
        [task]="selectedOption[fase]" [demoData]="currentDemoData" [liveData]="currentLiveData" [round]="round"
        [started]="started" [ready]="ready" [demo]="demo" [startFunction]="start" [submitTask]="submitTask"
        [timestamp]="timestamp" [checkRound]="checkRound" [currentAnswers]="currentAnswers"
        [updateCorrectness]="updateCorrectness" [overview]="overview" [dialogOpen]="dialogOpen"
        [updateCorrectAnswersCount]="updateCorrectAnswersCount" [getReady]="getReady">

      </app-categorisation>

      <!--RECOGNITION TASK-->
      <app-recognition *ngIf="(selectedOption[fase] === 'recognition') && !overview && !testFinished" [startFunction]="startRecognition"
        [data]="currentLiveData" [started]="started" [block]="block" [round]="round" [currentAnswers]="currentAnswers"
        [timestamp]="timestamp" [checkRound]="checkRound" [recognitionTask]="recognitionTask" [overview]="overview" 
        [computePercentage]="computePercentage">

      </app-recognition>

      <div *ngIf="testFinished" style="text-align: -webkit-center;text-align: -moz-center; padding: 2rem 0px">
        <p style="font-size: 1.5em; font-family: akzidenz-grotesk-light;">{{'SUCCESS_TEST' | translate}}</p>
      </div>

    </div>
  </div>
</div>